(function () {
    'use strict';

    function localeDateString() {
        return function (value) {
            var timevalue = moment(value);
            return timevalue.format('MM/DD/YYYY hh:mm A z');
        };
    }

    angular.module('ecap.common').filter('localeDateString', localeDateString);
})();